var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Sonne_2","key":0}),React.createElement("g",{"id":"Sonne_2_1_","key":1}),React.createElement("g",{"id":"Wolke_x5F_03_x5F_hell","key":2}),React.createElement("g",{"id":"Wolke_x5F_01_x5F_dunkel_2","key":3}),React.createElement("path",{"fill":"#154889","d":"M28.065,2.866C19.672,2.865,11.611,2.87,3.935,2.87c-0.693-0.03-1.088,0.443-1.062,1.2V28\r\n\tc0.003,0.51,0.22,1.123,0.924,1.135c8.493-0.003,16.631-0.001,24.404-0.002c0.704-0.012,0.923-0.625,0.926-1.135V4.066\r\n\tC29.152,3.309,28.757,2.836,28.065,2.866z M25.047,25.207L6.953,25.22V6.785l18.094-0.004V25.207z","key":4}),React.createElement("circle",{"cx":"16.361","cy":"11.164","r":"2.203","key":5}),React.createElement("rect",{"x":"14.597","y":"14.876","width":"3.528","height":"7.896","key":6})]);
}

Info.displayName = "Info";

Info.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = Info;

Info.default = Info;
